export default {
  name: 'groupJournalTree',
  menuPermList: {
    url: '/magazine/menuPermList.do'
  },
  journalList: {
    url: '/magazine/journalList.do'
  }
}
